import useAxios from "../../hooks/useAxios";

const usePrismSubscriptionNoteService = () => {
  const axiosNotes = useAxios();
  const axiosCreateNote = useAxios();
  const axiosUpdateNote = useAxios();
  const axiosDeleteNote = useAxios();

  const getSubscriptionNotes = async (subscriptionId) =>
    axiosNotes.fetchData({
      url: `/prism/subscriptions/${subscriptionId}/notes`,
      method: "GET",
    });

  const createSubscriptionNote = async (subscriptionId, data) =>
    axiosCreateNote.fetchData({
      url: `/prism/subscriptions/${subscriptionId}/notes`,
      method: "POST",
      data,
    });

  const updateSubscriptionNote = async (subscriptionId, noteId, data) =>
    axiosUpdateNote.fetchData({
      url: `/prism/subscriptions/${subscriptionId}/notes/${noteId}`,
      method: "PUT",
      data,
    });

  const deleteSubscriptionNote = async (subscriptionId, noteId) =>
    axiosDeleteNote.fetchData({
      url: `/prism/subscriptions/${subscriptionId}/notes/${noteId}`,
      method: "DELETE",
    });

  return {
    getSubscriptionNotes,
    subscriptionNoteLoading: axiosNotes.loading,
    subscriptionNoteError: axiosNotes.error,
    createSubscriptionNote,
    createSubscriptionNoteLoading: axiosCreateNote.loading,
    updateSubscriptionNote,
    updateSubscriptionNoteLoading: axiosUpdateNote.loading,
    deleteSubscriptionNote,
    deleteSubscriptionNoteLoading: axiosDeleteNote.loading,
  };
};

export default usePrismSubscriptionNoteService;
